import * as React from 'react';
import { useEffect } from 'react';

import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import Box from '@mui/material/Box';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { AppRoutes } from 'utilitys/appRoutes/AppRoutes';

import { useBattleCardsStore } from 'store/battlecards.store';
import { useProjectTreeStore } from 'store/projectContract.store';
import { useVersionStore } from 'store/version.store';

import { MuiIcon } from 'components/common/Icons/base/MuiIcon/MuiIcon';

import classes from 'components/Mobile/components/navbar/navbar.module.scss';
import { addFilterAndGetNewFilter } from 'components/Mobile/mobile.utils';
import { mobileAppConfig } from 'components/Mobile/mobileConfig';

export const NavbarMobile = () => {
    const [pageValue, setPageValue] = React.useState(0);
    const location = window.location.pathname;
    const contract = useProjectTreeStore((state) => state.contract);
    const project = useProjectTreeStore((state) => state.project);

    const version = useVersionStore((state) => state.version);
    const versionDbId = version?.id;
    const versionHashcode = version?.versionHashCode;
    const { path } = useRouteMatch();
    const { setFilterData } = useBattleCardsStore();
    const history = useHistory();

    const goToActivities = () => {
        if (project && contract && versionDbId) {
            const { filterPayload, querystring } = addFilterAndGetNewFilter({
                versionId: versionDbId,
                contractId: contract.id,
                filters: {},
                projectId: project.id,
            });
            setFilterData(filterPayload);
            const activitiesPathWithParams = `/${AppRoutes.MOBILE}/${mobileAppConfig.activities.link}/${versionHashcode}?${querystring}`;
            history.push(activitiesPathWithParams);
        }
    };

    useEffect(() => {
        const routes = [
            { path: mobileAppConfig.home.link, value: 0 },
            { path: mobileAppConfig.activities.link, value: 1 },
            { path: mobileAppConfig.notifications.link, value: 2 },
        ];

        const match = routes.find((route) => location.includes(route.path));
        if (match) {
            setPageValue(match.value);
        } else {
            setPageValue(0); // in no match was found, which should not happen, then set bottom navigation to home
        }
    }, [location]);

    return (
        <div className={classes.mobileNavbar}>
            <Box sx={{ width: '100%' }}>
                {versionHashcode && (
                    <BottomNavigation
                        sx={{
                            backgroundColor: 'var(--bottom-mobile-navbar-bg)',
                        }}
                        showLabels
                        value={pageValue}
                        onChange={(_, newValue) => {
                            setPageValue(newValue);
                        }}
                    >
                        <BottomNavigationAction
                            label={mobileAppConfig.home.title}
                            onClick={() => {
                                history.push(`${path}/${mobileAppConfig.home.link}/${versionHashcode}`);
                            }}
                            icon={
                                <MuiIcon
                                    icon={'home'}
                                    type={'outlined'}
                                    fontSize={'4.2rem'}
                                    color={pageValue === 0 ? 'var(--status_summary_blue)' : ''}
                                />
                            }
                            sx={{
                                '& .MuiBottomNavigationAction-label': {
                                    fontSize: '1.2rem',
                                },
                                '& .MuiBottomNavigationAction-label.Mui-selected': {
                                    fontSize: '1.6rem',
                                },
                            }}
                        />
                        <BottomNavigationAction
                            label={mobileAppConfig.activities.title}
                            onClick={() => {
                                goToActivities();
                            }}
                            icon={
                                <MuiIcon
                                    icon={'folderCheck'}
                                    type={'outlined'}
                                    fontSize={'4.2rem'}
                                    color={pageValue === 1 ? 'var(--status_summary_blue)' : ''}
                                />
                            }
                            sx={{
                                '& .MuiBottomNavigationAction-label': {
                                    fontSize: '1.2rem',
                                },
                                '& .MuiBottomNavigationAction-label.Mui-selected': {
                                    fontSize: '1.6rem',
                                },
                            }}
                        />
                        <BottomNavigationAction
                            label={mobileAppConfig.notifications.title}
                            onClick={() => {
                                history.push(AppRoutes.buildPath(AppRoutes.MOBILE, mobileAppConfig.notifications.link));
                            }}
                            icon={
                                <MuiIcon
                                    icon={'notifications'}
                                    type={'outlined'}
                                    color={pageValue === 2 ? 'var(--status_summary_blue)' : ''}
                                    fontSize={'4.2rem'}
                                />
                            }
                            sx={{
                                '& .MuiBottomNavigationAction-label': {
                                    fontSize: '1.2rem',
                                },
                                '& .MuiBottomNavigationAction-label.Mui-selected': {
                                    fontSize: '1.6rem',
                                },
                            }}
                        ></BottomNavigationAction>
                    </BottomNavigation>
                )}
            </Box>
        </div>
    );
};
